export const COLORS = {
    aha_green: "#12a9ae",
    aha_orange: "#F7941E",
    aha_black: "#444A64",
    aha_light_blue: "#DBEDF2",
    aha_light_blue_200: "#D9EAE9",
    aha_light_blue_500: "#BEDDDC",
    aha_dark_blue: "#444A63",
};
